import axios from 'axios';

// TODO: change foor live
// const API_URL = import.meta.env.VITE_API_URL;
const API_URL ='https://rte-server.michaeltsegaye00.workers.dev'
// Create an axios instance with default configurations
const api = axios.create({
  baseURL: API_URL,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});



export const searchBooks = async (query) => {
  try {
    const response = await api.post(`${API_URL}/search`, { title: query });
    return response.data;
  } catch (error) {
    console.error('Error searching books:', error);
    throw error;
  }
};

export const getBookDetails = async (bookId) => {
  try {
    const response = await axios.post(`${API_URL}/book`, { info: bookId });
    return response.data;
  } catch (error) {
    console.error('Error fetching book details:', error);
    throw error;
  }
};

export const getSimilarBooks = async (bookRef) => {
  try {
    const response = await axios.post(`${API_URL}/similar`, { title: bookRef });
    return response.data;
  } catch (error) {
    console.error('Error fetching similar books:', error);
    throw error;
  }
};